module.exports = __webpack_public_path__ + "media/images/my/bnr-mypage-inquiry-sm-fdab1039ecb2569956c1ef75f49b55f3.svg";